import React, { useState, useEffect } from "react";
import axios from "axios";

const BASEURL = import.meta.env.VITE_REACT_APP_BACKEND_BASEURL;

const Athletes = () => {
  const [athletes, setAthletes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editAthlete, setEditAthlete] = useState(null); // objeto atleta em edição ou null
  const [formData, setFormData] = useState({
    number: "",
    name: "",
    surname: "",
    function: "",
  });

  // Busca atletas
  const fetchAthletes = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASEURL}/athletes`);
      setAthletes(res.data);
    } catch (err) {
      alert("Erro ao buscar atletas");
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchAthletes();
  }, []);

  // Abre modal para novo ou editar
  const openModal = (athlete = null) => {
    if (athlete) {
      setEditAthlete(athlete);
      setFormData({
        number: athlete.number || "",
        name: athlete.name || "",
        surname: athlete.surname || "",
        function: athlete.function || "",
      });
    } else {
      setEditAthlete(null);
      setFormData({
        number: "",
        name: "",
        surname: "",
        function: "",
      });
    }
    setModalOpen(true);
  };

  // Fecha modal
  const closeModal = () => {
    setModalOpen(false);
  };

  // Atualiza form
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((f) => ({ ...f, [name]: value }));
  };

  // Submete form para criar ou atualizar
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editAthlete) {
        // update
        await axios.put(`${BASEURL}/athletes/${editAthlete._id}`, formData);
        // alert("Atleta atualizado");
      } else {
        // create
        await axios.post(`${BASEURL}/athletes`, formData);
        // alert("Atleta criado");
      }
      closeModal();
      fetchAthletes();
    } catch (err) {
      alert("Erro ao salvar atleta");
      console.error(err);
    }
  };

  // Remove atleta com confirmação
  const handleRemove = async (id) => {
    if (!window.confirm("Confirma remoção deste atleta?")) return;
    try {
      await axios.delete(`${BASEURL}/athletes/${id}`);
      //   alert("Atleta removido");
      fetchAthletes();
    } catch (err) {
      alert("Erro ao remover atleta");
      console.error(err);
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-4">
      <h1 className="text-2xl mb-4 font-bold">Lista de Atletas</h1>
      <button
        onClick={() => openModal()}
        className="mb-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        Novo Atleta
      </button>

      {loading ? (
        <p>Carregando atletas...</p>
      ) : (
        <table className="w-full border-collapse border border-gray-300 text-sm">
          <thead>
            <tr className="bg-gray-200">
              <th className="border border-gray-300 p-2 text-left">Número</th>
              <th className="border border-gray-300 p-2 text-left">Nome</th>
              <th className="border border-gray-300 p-2 text-left">
                Sobrenome
              </th>
              <th className="border border-gray-300 p-2 text-left">Função</th>
              <th className="border border-gray-300 p-2 text-center">Ações</th>
            </tr>
          </thead>
          <tbody>
            {athletes.length === 0 && (
              <tr>
                <td colSpan="5" className="text-center p-4">
                  Nenhum atleta cadastrado
                </td>
              </tr>
            )}
            {athletes.map((athlete) => (
              <tr key={athlete._id} className="hover:bg-gray-100">
                <td className="border border-gray-300 p-2">{athlete.number}</td>
                <td className="border border-gray-300 p-2">{athlete.name}</td>
                <td className="border border-gray-300 p-2">
                  {athlete.surname}
                </td>
                <td className="border border-gray-300 p-2">
                  {athlete.function}
                </td>
                <td className="border border-gray-300 p-2 text-center space-x-2">
                  <button
                    onClick={() => openModal(athlete)}
                    className="px-2 py-1 bg-yellow-400 rounded hover:bg-yellow-500"
                  >
                    Editar
                  </button>
                  <button
                    onClick={() => handleRemove(athlete._id)}
                    className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                  >
                    Remover
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {modalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
          onClick={closeModal}
        >
          <div
            className="bg-white rounded p-6 w-96"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-xl mb-4">
              {editAthlete ? "Editar Usuário" : "Novo Usuário"}
            </h2>
            <form onSubmit={handleSubmit} className="space-y-3">
              <div>
                <label className="block mb-1 font-semibold">Número</label>
                <input
                  type="number"
                  name="number"
                  value={formData.number}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded px-2 py-1"
                />
              </div>
              <div>
                <label className="block mb-1 font-semibold">Nome</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full border border-gray-300 rounded px-2 py-1"
                />
              </div>
              <div>
                <label className="block mb-1 font-semibold">Sobrenome</label>
                <input
                  type="text"
                  name="surname"
                  value={formData.surname}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded px-2 py-1"
                />
              </div>
              <div>
                <label className="block mb-1 font-semibold">Função</label>
                <input
                  type="text"
                  name="function"
                  value={formData.function}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded px-2 py-1"
                />
              </div>
              <div className="flex justify-end space-x-2 mt-4">
                <button
                  type="button"
                  onClick={closeModal}
                  className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Salvar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Athletes;
